"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWishlist = void 0;
var _useCustomerProductList = require("../commerce-api/hooks/useCustomerProductList");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const PWA_DEFAULT_WISHLIST_NAME = 'PWA wishlist';
const PWA_DEFAULT_WISHLIST_TYPE = 'wish_list';
const useWishlist = () => (0, _useCustomerProductList.useCustomerProductList)(PWA_DEFAULT_WISHLIST_NAME, PWA_DEFAULT_WISHLIST_TYPE);
exports.useWishlist = useWishlist;